const editorialByMovieId = {
  586: {
    whyPicked: 'A political fixer and a Hollywood producer manufacture a war to distract voters from a presidential scandal. Barry Levinson pairs Robert De Niro\'s quiet calculation with Dustin Hoffman\'s showmanship in a darkly funny satire about who makes the stories we believe.',
    bestWatchedWhen: 'You want a sharp, cynical comedy about politics and media, with a conversation afterward about how spectacle can replace the truth.',
    ifYouLiked: ['Network', 'In the Loop', 'Thank You for Smoking']
  },
  37233: {
    whyPicked: 'A dream job at a prestigious law firm becomes a trap. Sydney Pollack turns John Grisham\'s legal thriller into a tense story of ambition, loyalty, and the price of success, led by Tom Cruise and Gene Hackman.',
    bestWatchedWhen: 'You want a patient, twisty legal thriller that lets the pressure build, with time to settle into its web of secrets.',
    ifYouLiked: ['The Pelican Brief', 'Michael Clayton', 'A Few Good Men']
  },
  14684: {
    whyPicked: 'A scholarship student wins acceptance at an elite school, then confronts antisemitism when his classmates discover he is Jewish. The drama turns belonging into a test of who will stand beside him.',
    bestWatchedWhen: 'You want a serious character drama about privilege, loyalty, and the cost of fitting in, with room for a conversation afterward.',
    ifYouLiked: ['Dead Poets Society', 'Scent of a Woman', 'Finding Forrester']
  },
  840326: {
    whyPicked: 'A lean, brutal, oddly funny action myth: one old prospector, stolen gold, and a Nazi platoon learning they picked the wrong man.',
    bestWatchedWhen: 'Best watched when you want something short, physical, and cathartic — a midnight-movie punch rather than a slow prestige drama.',
    ifYouLiked: ['John Wick', 'Mad Max: Fury Road', 'Inglourious Basterds']
  }
};

export const getFilmOfMonthEditorial = (movie) => {
  if (!movie) return null;

  return editorialByMovieId[movie.id] || null;

};
